import {DataObjectId} from '../data-object'
import {ObjUtil} from 'yougile-util'
import {PermissionObject, PermissionsById} from './permission-object'

export interface VisibilityOptions {
  considerAsMy?: boolean
  considerAsWithMe?: boolean
}

export interface ObjectVisibility {
  all?: boolean
  my?: boolean
  withMe?: boolean
  createdByMe?: boolean
}

export interface CompanyVisibility {
  objects: {[objectId: string]: ObjectVisibility}
  users: DataObjectId[]
}

export interface CompanyVisibilityState {
  companyId: DataObjectId
  revision: number
  admins: DataObjectId[]
  projects: {[projectId: string]: DataObjectId[]} // project -> users
  groups: {[groupId: string]: CompanyVisibility}
}

export const getObjectVisibility = (
  obj: PermissionObject
): ObjectVisibility => {
  if (!obj || !obj.permissions) {
    return {}
  }
  switch (obj.type) {
    case 'project':
      return getObjectVisibility({
        type: 'board',
        permissions: obj.permissions.boards,
        objectId: obj.objectId
      })
    case 'board':
      return getObjectVisibility({
        type: 'column',
        permissions: obj.permissions.columns,
        objectId: obj.objectId
      })
    case 'column': {
      const {allTasks, myTasks, withMeTasks, createdByMeTasks} = obj.permissions
      return {
        all: allTasks?.show,
        my: myTasks?.show,
        withMe: withMeTasks?.show,
        createdByMe: createdByMeTasks?.show
      }
    }
    case 'task':
      return {all: obj.permissions.show}
    default:
      return {}
  }
}

export const isDirectlyVisible = (obj: PermissionObject): boolean => {
  const v = getObjectVisibility(obj)
  return v && ((v.all || v.createdByMe || v.my || v.withMe) ?? false)
}

export const getPermissionsVisibility = (
  users: DataObjectId[],
  permissions: PermissionsById
): CompanyVisibility => {
  if (!permissions || !users) {
    return {objects: {}, users: []}
  }
  return {
    objects: ObjUtil.map(permissions, (_, p) => getObjectVisibility(p)),
    users
  }
}
